import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

// components
import FormSelectDialog from "../../index";
import { ControlStyled, ContentWrapperStyled } from "../../components/Control";
import Content from "./Content";

// styles
import { convertPxToRem } from "frontend/components/helpers";
export const FormSelectDialogEditStyled = styled.div`
    ${ControlStyled} {
        border: none;

        ${ContentWrapperStyled} {
            gap: ${convertPxToRem(8)};
        }
    }
`;

// component
export const FormSelectDialogEdit = ({ className, ...rest }) => {
    return (
        <FormSelectDialogEditStyled className={className}>
            <FormSelectDialog {...rest}>
                <Content />
            </FormSelectDialog>
        </FormSelectDialogEditStyled>
    );
};

export default FormSelectDialogEdit;

// prop-types
FormSelectDialogEdit.propTypes = {
    className: PropTypes.any
};
